import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRequestTrackingModal } from '../../contexts/RequestTrackingModalContext';
import { APP_ROUTES } from '../../navigation/appRoutes';

/**
 * Legacy route — opens the global request tracker modal and returns to the dashboard.
 */
export default function RequestTrackingPage() {
  const navigate = useNavigate();
  const { openRequestTracker } = useRequestTrackingModal();

  useEffect(() => {
    openRequestTracker();
    navigate(APP_ROUTES.dashboard.overview, { replace: true });
  }, [openRequestTracker, navigate]);

  return null;
}
